import React from 'react'
import styled from 'styled-components'

import voucherRiparideImage from 'assets/images/voucher-riparide.jpg' // eslint-disable-line
import voucherListingImage from 'assets/images/voucher-listing.jpg' // eslint-disable-line
import voucherStoryImage from 'assets/images/voucher-story.jpg' // eslint-disable-line
import RiparideSmallLogo from '../../components/icons/RiparideSmallLogo'

import { media } from '../../styles/media'

const Wrapper = styled.div`
  position: relative;
  width: 300px;
  height: 300px;

  font-size: 16px;

  border-radius: 6px;
  overflow: hidden;

  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  background-color: black;
  background-image: url(${({ backgroundImage }) => backgroundImage});

  ${({ large }) =>
    large &&
    `
    font-size: 20px;
  `}
`

const Overlay = styled.div`
  position: relative;
  width: 100%;
  height: 100%;

  padding: 40px;

  display: flex;
  align-items: center;
  justify-content: center;

  color: white;
  background-color: rgba(0, 0, 0, 0.3);

  svg {
    position: absolute;
    width: 60px;
    height: 45px;
    top: 30px;
    margin: 0 auto;
  }

  ${({ large }) =>
    large &&
    `
    ${media.md`
      padding:  40px;
    `}
  `}
`

const ListingType = styled.div`
  width: 100%;
  margin-top: 10px;
  padding: 12px 0;

  font-size: 36px;
  text-align: center;
  text-transform: uppercase;

  ${({ large }) =>
    large &&
    `
    ${media.md`
      padding: 24px 0;
    `}
  `}
`

const ListingTitle = styled.div`
  position: absolute;
  left: 20px;
  bottom: 20px;
  font-size: 1em;

  ${({ large }) =>
    large &&
    `
      left: 40px;
      bottom: 40px;
    `}
`

const typeToImage = (type) => {
  switch (type) {
    case 'listing':
      return voucherListingImage
    case 'story':
      return voucherStoryImage
    default:
      return voucherRiparideImage
  }
}

const Voucher = ({ title, type, large, backgroundImage }) => (
  <Wrapper
    className="voucher"
    backgroundImage={backgroundImage || typeToImage(type)}
    large={large}
  >
    <Overlay large={large}>
      <RiparideSmallLogo />
      <ListingType large={large}>
        {type ? `${type} Voucher` : 'THE GIFT OF ADVENTURE'}
      </ListingType>
      {title && <ListingTitle large={large}>{title}</ListingTitle>}
    </Overlay>
  </Wrapper>
)

export default Voucher
